import allLocales from '@/localization/locales';

export default {
    namespaced: true,
    state() {
        const state = {};
        for (const l of allLocales)
            state[l.locale] = l;

        return state;
    },
    actions: {
        import({commit}, localeObj) {
            commit('update', localeObj);
        },
    },
    mutations: {
        update(state, localeObj) {
            state[localeObj.locale] = localeObj;
        },
    },
};